<app-header></app-header>
<div id="mainContent">
    <div class="container ecomm-bck" >
        <div class="main-wrap" >
          <router-outlet></router-outlet>
        </div>
      </div>
</div>
<app-footer></app-footer>
